import JsBarcode from "jsbarcode";

const calculateCheckDigit = (base) => {
  const digits = base.split("").map(Number);
  let sum = 0;
  for (let i = 0; i < digits.length; i++) {
    sum += i % 2 === 0 ? digits[i] : digits[i] * 3;
  }
  return (10 - (sum % 10)) % 10;
};

const generateRandomGTIN13 = () => {
  const countryCode = "611"; // Morocco country code
  const productCode = Math.floor(100000000 + Math.random() * 900000000); // Random 9 digits
  const baseGTIN13 = countryCode + productCode;
  const checkDigit = calculateCheckDigit(baseGTIN13);
  return baseGTIN13 + checkDigit;
};

const generateBarcode = () => {
  const barcodeValue = generateRandomGTIN13();

  // Generate the barcode as a Data URL
  const svgElement = document.createElement("svg");
  JsBarcode(svgElement, barcodeValue, {
    format: "EAN13",
    lineColor: "#0b0b0b",
    width: 2,
    height: 100,
    displayValue: true,
  });

  return { barcodeValue, svgHTML: svgElement.outerHTML };
};

export const generateBarcodeFromValue = (value) => {
  if (!value) return "";

  const cleanValue = String(value).replace(/\D/g, "");
  let finalValue = cleanValue;

  if (cleanValue.length === 12) {
    finalValue = cleanValue + calculateCheckDigit(cleanValue);
  } else if (cleanValue.length === 13) {
    const checkDigit = calculateCheckDigit(cleanValue.slice(0, 12));
    finalValue = cleanValue.slice(0, 12) + checkDigit;
  } else {
    return ""; // Invalid length
  }

  const svgElement = document.createElement("svg");
  try {
    JsBarcode(svgElement, finalValue, {
      format: "EAN13",
      lineColor: "#0b0b0b",
      width: 2,
      height: 80,
      displayValue: true,
    });
    return svgElement.outerHTML;
  } catch (e) {
    console.error("Failed to generate barcode", e);
    return "";
  }
};

export default generateBarcode;